<template>
  <ul>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[belongs_to_checklist_eq]': true })" class="dropdown-item">
        {{ $t('root.filters.yes_checklist') }}
      </router-link>
    </li>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[belongs_to_checklist_eq]': false })" class="dropdown-item">
        {{ $t('root.filters.no_checklist') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
  }
</script>
